<div class="h-full w-full flex flex-col overflow-y-auto scrollbar-transparent">
    <div class="space-y-8">
        <div class="border-b dark:border-white/10 border-gray-200 pb-4">


            <h2 class="text-base/7 font-semibold text-primary">Content Distribution</h2>
            <p class="mt-1 text-sm/6 text-secondary">Where will this content be used?</p>

            <div class="mt-10 grid grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6 px-2">
                <div class="sm:col-span-full">
                    <label for="comment" class="block text-sm/6 font-medium text-primary">
                        Select Platforms
                        <p class="text-xs text-secondary">Select the platforms where you want to distribute the
                            content, of select "UGC Only" if the content is not to be posted on socials.</p>
                    </label>

                    <ul role="list" class="mt-3 grid grid-cols-1 gap-5 sm:grid-cols-2 sm:gap-6 lg:grid-cols-4">
                        @for (channel of socialChannelOptions; track channel.channelId) {
                        <li class="col-span-1 flex rounded-md cursor-pointer" (click)="selectChannel(channel)"
                            [class]="isChannelItemSelected(channel) ? 'outline outline-primary -outline-offset-1' : ''">
                            <div
                                class="flex w-16 shrink-0 items-center justify-center rounded-l-md bg-primary/10 text-accent border-t border-l border-b border-primary">
                                <img [src]="channel.channelIcon" alt="" class="size-8" />
                            </div>
                            <div
                                class="flex flex-1 items-center justify-between truncate rounded-r-md border-t border-r border-b border-zinc-300 dark:border-white/10">
                                <div class="flex-1 truncate px-4 py-2 text-sm">
                                    <span class="font-medium text-primary">{{ channel.channelName }}</span>
                                    <p class="text-secondary truncate">{{ channel.shortName }}</p>
                                </div>
                                <div class="shrink-0 pr-2 flex items-center justify-center text-primary">
                                    @if (isChannelItemSelected(channel)) {
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                        fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                        stroke-linejoin="round" class="size-6">
                                        <circle cx="12" cy="12" r="10" />
                                        <path d="m9 12 2 2 4-4" />
                                    </svg>
                                    }
                                </div>
                            </div>
                        </li>
                        }
                    </ul>
                </div>


                <h2 class="text-base/7 font-semibold text-primary">Where will this content be used?</h2>
                <p class="text-sm/6 text-secondary">Select the platforms where you want to distribute the content, or
                    select
                    "UGC Only" if the content is not to be posted on socials.</p>

                <ul role="list" class="mt-3 grid grid-cols-1 gap-6 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4">
                    @for (channel of socialChannelOptions; track channel.channelId) {
                    @if (channel.channelId == -1) {
                    <li class="social-card cursor-pointer" (click)="selectUgcOnly(channel)"
                        [class]="createBriefService.selectedUgcOnly() ? 'social-card-selected' : 'social-card'">
                        <div
                            class="mx-auto size-18 shrink-0 rounded-full bg-zinc-100 dark:bg-gray-600 outline -outline-offset-1 outline-white/10 flex items-center justify-center">
                            <img [src]="channel.channelIcon" alt="" class="size-12" />
                        </div>
                        <h3 class="mt-4 text-sm font-medium text-primary">{{ channel.channelName }}</h3>
                    </li>
                    } @else {
                    <li class="social-card" (click)="selectInfluencerBrief(channel)"
                        [class]="isChannelSelected(channel) ? 'social-card-selected' : 'social-card'">
                        <div
                            class="mx-auto size-18 shrink-0 rounded-full bg-gray-100 dark:bg-gray-700 outline -outline-offset-1 outline-white/10 flex items-center justify-center">
                            <img [src]="channel.channelIcon" alt="" class="size-10" />
                        </div>
                        <h3 class="mt-4 text-sm font-medium text-primary">{{ channel.channelName }}</h3>
                    </li>
                    }
                    }
                </ul>
            </div>

            <div class="border-b dark:border-white/10 border-gray-200 pb-4">
                <h2 class="text-base/7 font-semibold text-primary">Content Orientation</h2>
                <p class="text-sm/6 text-secondary">Orientation automatically set based on selected platforms. For UGC
                    Only,
                    select the orientation manually.</p>

                <ul role="list" class="mt-3 grid grid-cols-1 gap-5 sm:grid-cols-2 sm:gap-6 lg:grid-cols-3">
                    @for (videoFormat of allVideoFormats; track videoFormat.id) {
                    <li class="col-span-1 flex rounded-md"
                        (click)="createBriefService.selectedVideoFormat.set(videoFormat)"
                        [class]="createBriefService.selectedBriefGoal()?.id === videoFormat.id ? 'border-primary' : 'border-zinc-500'">
                        <div class="flex w-16 shrink-0 items-center justify-center rounded-l-md text-sm font-medium"
                            [class]="videoFormat.color">
                            @switch (videoFormat.id) {
                            @case (0) {
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                stroke-linejoin="round" class="size-8">
                                <rect width="14" height="20" x="5" y="2" rx="2" ry="2" />
                                <path d="M12 18h.01" />
                            </svg>
                            }
                            @case (1) {
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                stroke-linejoin="round" class="size-8">
                                <rect width="20" height="14" x="2" y="3" rx="2" />
                                <line x1="8" x2="16" y1="21" y2="21" />
                                <line x1="12" x2="12" y1="17" y2="21" />
                            </svg>
                            }
                            @case (2) {
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                stroke-linejoin="round" class="size-8">
                                <rect width="18" height="18" x="3" y="3" rx="2" />
                            </svg>
                            }
                            }
                        </div>

                        <div
                            class="flex flex-1 items-center justify-between truncate rounded-r-md border-t border-r border-b border-zinc-300 dark:border-white/10">
                            <div class="flex-1 truncate px-4 py-2 text-sm">
                                <a class="font-medium text-primary hover:text-gray-200">{{ videoFormat.name }}</a>
                                <p class="text-secondary truncate">{{ videoFormat.description }}</p>
                            </div>
                            <div class="shrink-0 pr-2 flex items-center justify-center text-primary">
                                @if (createBriefService.selectedVideoFormat()?.id === videoFormat.id) {
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                    fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                    stroke-linejoin="round" class="size-6">
                                    <circle cx="12" cy="12" r="10" />
                                    <path d="m9 12 2 2 4-4" />
                                </svg>
                                }
                            </div>
                        </div>

                    </li>
                    }
                </ul>
            </div>


            @if (!createBriefService.selectedUgcOnly() && createBriefService.selectedPrimaryChannel()) {
            <div class="border-b dark:border-white/10 border-gray-200 pb-4">
                <h2 class="text-base/7 font-semibold text-primary">Post Metadata</h2>
                <p class="text-sm/6 text-secondary">Do you require specific metadata for the post?</p>

                <div class="mt-2 w-full grid grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6">
                    <div class="sm:col-span-2 border border-zinc-300 dark:border-white/10 rounded-md p-4">
                        <label for="suggested-caption" class="block text-sm/6 font-medium text-primary">
                            Caption
                            <p class="text-xs text-secondary">What should the caption be?</p>
                        </label>
                        <div class="mt-2">
                            <textarea id="suggested-caption" name="suggested-caption" rows="3"
                                placeholder="Enter your caption here... (optional)" class="input-textarea text-primary"
                                [value]="createBriefService.suggestedCaption()"
                                (input)="onSuggestedCaptionInput($event)"></textarea>
                        </div>
                    </div>

                    <div class="sm:col-span-2 border border-zinc-300 dark:border-white/10 rounded-md p-4">
                        <label for="comment" class="block text-sm/6 font-medium text-primary">
                            Hashtags
                            <p class="text-xs text-secondary">Set required hashtags.</p>
                        </label>
                        <div class="mt-2">
                            <textarea id="suggested-hastags" name="suggested-hastags" rows="3"
                                placeholder="Enter your hashtags here... (optional)" class="input-textarea text-primary"
                                [value]="createBriefService.suggestedHastags()"
                                (input)="onSuggestedHastagsInput($event)"></textarea>
                        </div>
                    </div>

                    <div class="sm:col-span-2 border border-zinc-300 dark:border-white/10 rounded-md p-4">
                        <label for="comment" class="block text-sm/6 font-medium text-primary">
                            CTA Link
                            <p class="text-xs text-secondary">Link the post to your page.</p>
                        </label>

                        <div class="mt-2 flex">
                            <div
                                class="flex shrink-0 items-center rounded-l-md bg-white/50 dark:bg-white/5 px-3 text-base text-gray-500 dark:text-gray-400 outline outline-1 -outline-offset-1 outline-zinc-300 dark:outline-white/10 sm:text-sm/6">
                                https://</div>
                            <input id="cta-link" type="url" placeholder="www.example.com" autocomplete="url"
                                class="input-url text-primary text-base rounded-r-md flex-1"
                                [value]="createBriefService.callToActionLink()"
                                (input)="onSuggestedCallToActionLinkInput($event)" />
                        </div>
                    </div>
                </div>
            </div>
            }
        </div>
    </div>